import type { LoadType } from '@dicetechnology/vesper-sdk-web';
import clsx from 'clsx';
import { memo, useEffect, useState } from 'react';
import '@dicetechnology/vesper-sdk-web/vesper-sdk.css';

import { usePlayerManager } from '../../utils/playerManager';

import EventBusInstance from '@core/eventbus';
import { withErrorBoundary } from '@shared/ErrorBoundary';

import * as styles from './styles.module.scss';

const VesperPlayer = ({ divId = '#vesper-player', id, type }: { divId?: string; id: string; type: LoadType }) => {
  const { data: manager } = usePlayerManager(divId);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    if (!manager) return;
    manager.load({ id, type });
  }, [manager, id, type]);

  useEffect(() => {
    const fullscreenMode = (fullscreen) => {
      setIsFullscreen(fullscreen);
    };

    EventBusInstance.on('uefatv-fullscreen', fullscreenMode, this);
    return () => {
      manager?.destroy();
      EventBusInstance.off('uefatv-fullscreen', fullscreenMode, this);
    };
  }, [manager]);

  return <div id={divId} className={clsx(styles.vesperPlayer, isFullscreen && styles.fullscreen)} data-id={id} />;
};

export default memo(withErrorBoundary(VesperPlayer));
